$(window).on('load', function () {

    let windowWidth;

    function updateWindowWidth() {
        windowWidth = $(window).width();
    }

    $(window).resize(function () {
        updateWindowWidth();
    });

    updateWindowWidth();

    /**
     * Navicon toggle mobile
     */
    $('.header__navicon').on('click', () => {
        $('body').toggleClass('navigation-active');
        $('.header__navicon .hamburger').toggleClass('hamburger--active');
        $('.header__navigation').toggleClass('header__navigation--visible');
        $('.header__navigation').removeClass('header__navigation--hide-left');
        $('.sub-navigation').removeClass('sub-navigation--visible');

        // If window is on top, add scrolled class
        if ($(window).scrollTop() === 0) {
            $('.header').toggleClass('header--scrolled');
        }
    });

    /**
     * Sub navigation toggle mobile
     */
    if (windowWidth < 1180) {
        $('.header__navigation a.has-sub').on('click', function (e) {
            e.preventDefault();

            let sub = $(this).data('sub');

            $('.header__navigation').addClass('header__navigation--hide-left');
            $('.sub-navigation[data-sub="' + sub + '"]').addClass('sub-navigation--visible');
        });

        // Back button
        $('.sub-navigation__back').on('click', function () {
            $('.sub-navigation').removeClass('sub-navigation--visible');
            $('.header__navigation').removeClass('header__navigation--hide-left');
        });
    }

    /**
     * Sub navigation toggle desktop
     */
    if (windowWidth >= 1180) {
        $('.header__navigation a.has-sub').on('click', function (e) {
            e.preventDefault();
        });

        $('.header__navigation a.has-sub').mouseenter(function () {
            let sub = $(this).data('sub');

            setTimeout(function () {
                $('.sub-navigation[data-sub!="' + sub + '"]').removeClass('sub-navigation--visible');
            }, 100);
            $('.sub-navigation[data-sub="' + sub + '"]').addClass('sub-navigation--visible');
        });

        // Remove sub navigations when hovering non parent items
        $('.header__navigation a').not('.has-sub').mouseenter(function () {
            $('.sub-navigation').removeClass('sub-navigation--visible');
        });
        $('.header').mouseleave(function () {
            $('.sub-navigation').removeClass('sub-navigation--visible');
        });

        // Hide sub navigation if the cursor is left or right of the main navigation within .header
        let offsetLeft = $('.header__navigation').offset().left;
        let offsetRight = $('.header__navigation').offset().left + $('.header__navigation').outerWidth();
        let scrolledTop = 0;

        $(window).on('scroll', function () {
            scrolledTop = document.documentElement.scrollTop;
        });

        $(document).mousemove(function (e) {
            let headerArea = e.pageY - scrolledTop;

            // Make sure it only checks the position if the cursor is within the fixed <header>
            if (headerArea <= 100) {
                // Check if cursor is within offset left or right from the .header__navigation
                // Remove the sub navigation if that is the case
                if (e.pageX < offsetLeft || e.pageX > offsetRight) {
                    // Remove visible class from sub navigation
                    $('.sub-navigation').removeClass('sub-navigation--visible');
                }
            }
        });
    }

    // Check if user is scrolled from top
    headerScroll();

    $(window).on('scroll', () => {
        headerScroll();
    });

    // Footer toggle language switch
    $('.footer__language-select').on('click', function (e) {
        $('.footer__language ul').fadeToggle(300);
    });
});

/**
 * Header scroll
 */
const headerScroll = () => {
    if ($(window).scrollTop() >= 50) {
        if (!$('.header').hasClass('header--scrolled')) {
            $('.header').addClass('header--scrolled');
        }
    } else {
        $('.header').removeClass('header--scrolled');
    }
}

// **************
// function for navigating to specific #
// **************
// let navHeight = $(".header").height();
//
// $('a[href*="#"]').on("click", function (e) {
//     e.preventDefault();
//     $("html, body").animate(
//         {
//             scrollTop: $($(this).attr("href")).offset().top - navHeight - 60,
//         },
//         700,
//         "swing"
//     );
// });